import MenuItem from '@material-ui/core/MenuItem'
import Typography from '@material-ui/core/Typography'
import { ClassNameMap } from '@material-ui/styles'
import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

import { workspaceMenuItems } from './data'

type WorkspaceMenuItemsProps = {
  classes: ClassNameMap
  onClose: () => void
}

export default function WorkspaceMenuItems({
  classes,
  onClose,
}: WorkspaceMenuItemsProps) {
  return (
    <Fragment>
      {workspaceMenuItems.map((menuItem) => (
        <Link
          key={`key-${menuItem.name}`}
          to={menuItem.url}
          style={{ textDecoration: 'none' }}
          onClick={() => onClose()}
        >
          <MenuItem className={classes.menuItem}>
            <menuItem.icon className={classes.iconMenuWorkspace} />
            <Typography className={classes.textMenuItem}>
              {menuItem.name}
            </Typography>
          </MenuItem>
        </Link>
      ))}
    </Fragment>
  )
}
